import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=f4f1b8b2&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=f4f1b8b2&prod&scoped=true&lang=less"
import style1 from "./Footer.vue?vue&type=style&index=1&id=f4f1b8b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f1b8b2",
  null
  
)

export default component.exports